import React, { useState } from 'react';
import { Play } from 'lucide-react';
import VideoPopup from '../VideoPopup';

const IntelligenceCallout = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <section className="relative" data-testid="intelligence-callout">
      {/* Top angled edge - white diagonal */}
      <div 
        className="absolute top-0 left-0 right-0 h-20 bg-white z-10"
        style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 30%, 0 100%)'
        }}
      />
      
      {/* Main section with gradient background */}
      <div className="relative pt-32 pb-40 lg:pt-44 lg:pb-52 overflow-hidden">
        {/* Animated gradient background */}
        <div 
          className="absolute inset-0 hero-gradient-primary"
          aria-hidden="true"
        />
        
        {/* Subtle glow effects */}
        <div className="hero-glow-violet" aria-hidden="true" />
        <div className="hero-glow-steel" aria-hidden="true" />
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left - Content */}
            <div>
              {/* Powered by badge */}
              <div className="flex items-center gap-2 text-sm text-white/70 mb-6">
                <div 
                  className="w-2 h-2 rounded-full animate-pulse" 
                  style={{ background: 'linear-gradient(135deg, #667eea, #f093fb)' }} 
                />
                <span>BuildPilot App Intelligence</span>
              </div>
              
              <h2 className="font-serif text-4xl sm:text-5xl text-white mb-6 drop-shadow-lg">
                Always-on intelligence.
              </h2>
              <p className="text-lg text-white/70 leading-relaxed drop-shadow mb-6">
                BuildPilot App Intelligence is an always-on intelligence layer that monitors costs and helps guide critical decisions across your entire project.
              </p>
              <p className="text-lg text-white/70 leading-relaxed drop-shadow mb-8">
                Ongoing analysis of cost, progress and risk to keep you informed at every stage.
              </p>
              
              {/* Watch Promo Button with animated gradient text */}
              <button
                onClick={() => setShowVideo(true)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-full hover:bg-white/90 transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-[1.02]"
                data-testid="watch-promo-btn"
              >
                <Play className="w-4 h-4 text-gray-800 fill-gray-800" />
                <span className="gradient-text font-semibold">Watch our Promo</span>
              </button>
            </div>
            
            {/* Right - App Showcase Image */}
            <div className="relative flex justify-center items-center">
              <img 
                src="/buildpilot-app-ai-building-advice.webp" 
                alt="BuildPilot App Intelligence features showing smart building advice, cost predictions, and builder recommendations for Australian homes"
                className="w-full max-w-[340px] sm:max-w-md md:max-w-lg lg:max-w-2xl h-auto mx-auto sm:scale-100 lg:scale-125"
                loading="lazy"
                width="672"
                height="504"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom angled edge - white diagonal */}
      <div 
        className="absolute bottom-0 left-0 right-0 h-20 bg-white z-10"
        style={{
          clipPath: 'polygon(0 70%, 100% 0%, 100% 100%, 0 100%)'
        }}
      />
      
      {/* Video Popup */}
      <VideoPopup isOpen={showVideo} onClose={() => setShowVideo(false)} />
    </section>
  );
};

export default IntelligenceCallout;
